export const RO_LOCALE = 'ro';
export const EN_LOCALE = 'en';
export const DEFAULT_LOCALE = RO_LOCALE;
export const COOKIE_LOCALE = '_locale';

export const SET_LOCALE = 'SET_LOCALE';
export const setLocale = (locale) => ({ type: SET_LOCALE, payload: locale });

export const SET_DEFAULT_LOCALE = 'SET_DEFAULT_LOCALE';
export const setDefaultLocale = () => ({ type: SET_DEFAULT_LOCALE });
